import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default {
  exact: true,
  path: '/home/content/timeline',
  owner: '/home',
  authority: 'timeLineList',
  component: Loadable({
    loader: () => import('./index'),
    loading: () => <RouteLoading />
  })
};